import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

/**
 * School Demo Mode — a presentation layer, not a fork.
 *
 * 'school_demo' shows the six-section district journey and skips intermediary
 * landing pages. 'full' is the product exactly as it is. Both modes read the
 * same student, the same profile and the same intelligence.
 */
const ExperienceModeContext = createContext({ mode: 'full', setMode: () => {}, isDemo: false });

const KEY = 'fp_experience_mode';

export const ExperienceModeProvider = ({ children }) => {
  const { user } = useAuth();
  const [mode, setModeState] = useState('full');

  useEffect(() => {
    if (!user) return;
    const saved = localStorage.getItem(`${KEY}:${user.id}`);
    if (saved === 'school_demo' || saved === 'full') {
      setModeState(saved);
      return;
    }
    // District students land in the clean district journey by default.
    const isDistrictStudent = !!(user.organization_id || user.org_id) && user.role === 'student';
    setModeState(isDistrictStudent ? 'school_demo' : 'full');
  }, [user]);

  const setMode = (next) => {
    setModeState(next);
    if (user?.id) localStorage.setItem(`${KEY}:${user.id}`, next);
  };

  return (
    <ExperienceModeContext.Provider value={{ mode, setMode, isDemo: mode === 'school_demo' }}>
      {children}
    </ExperienceModeContext.Provider>
  );
};

export const useExperienceMode = () => useContext(ExperienceModeContext);
